// store/api/b2cApi.ts

import { UpdateOrderStatus } from "@/types/api";
import {
  AddCart,
  cCoupon,
  ColData,
  ColN,
  ColName,
  RemoveCart,
  UpdateDeliveredStatus,
} from "@/types/b2c";

const fetchB2CAPI = async (endpoint: string, options: RequestInit = {}) => {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_API_BASE_URL_FETCH}${endpoint}`,
    {
      headers: { "Content-Type": "application/json" },
      ...options,
    }
  );

  if (!response.ok) {
    throw new Error(`B2C API error: ${response.statusText}`);
  }

  const data = await response.json();
  return data;
};

export function createCollection(collectionData:ColN) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(`${process.env.NEXT_PUBLIC_API_BASE_URL_FETCH}/collections`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(collectionData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

// B2C Admin API Calls
export const fetchAllAdminUsersOrders = (UserID: string) =>
  fetchB2CAPI(`/list/orders/${UserID}`);
export const fetchB2cDashboard = () => fetchB2CAPI("/admin/dashboard");
export const fetchAllAdminUsers = () => fetchB2CAPI("/list/users");
export const fetchAllUsersRole = () => fetchB2CAPI("/list/fetch_usertype");
export const fetchAllCoupon = () => fetchB2CAPI("/list/fetch_coupons");
export const getAllInventory = () => fetchB2CAPI("/list/sku_inventory");
export const fetchAllUsersShipping = () => fetchB2CAPI("/list/shpping_users");
export const fetchAllProductAndSKU = () => fetchB2CAPI("/list/active-status");
export const fetchAlldealerProductSale = () =>
  fetchB2CAPI("/list/dealer_product_sale");
export const fetchAlldealerSKUSale = () => fetchB2CAPI("/list/dealer_sku");
export const toggleProductStatus = (prod_ID: number) =>
  fetchB2CAPI(`/list/product_toggle/${prod_ID}`);
export const toggleSKUStatus = (SKU_ID: number) =>
  fetchB2CAPI(`/list/sku_toggle/${SKU_ID}`);
export const updateUserShipping = (UserID: string) =>
  fetchB2CAPI(`/list/update_shpping_user/${UserID}`);
export const toggleCoupon = (id: number) =>
  fetchB2CAPI(`/list/toggle_coupons/${id}`);
export const createCoupon = (couponData: cCoupon) =>
  fetchB2CAPI(`/list/create_coupons`, {
    method: "POST",
    body: JSON.stringify(couponData),
  });

export const fetchAllAdminUsersCarts = () => fetchB2CAPI("/list/cart_users");
export const fetchAllUserCarts = (UserID: number) =>
  fetchB2CAPI(`/fetch_cart/${UserID}`);

export const updateDeliveredStatus = (updateData: UpdateDeliveredStatus) =>
  fetchB2CAPI("/list/update_delivered_status", {
    method: "POST",
    body: JSON.stringify(updateData),
  });

export const addProductInCollection = (collectionData: ColData) =>
  fetchB2CAPI("/collections-items", {
    method: "POST",
    body: JSON.stringify(collectionData),
  });

export const editCollection = (collectionData: ColName) => {
  const collection_id = collectionData?.collection_id;
  const collection_name = collectionData?.collection_name;
  fetchB2CAPI(`/collections/${collection_id}`, {
    method: "PUT",
    body: JSON.stringify({ collection_name }),
  });
};

export const addToCarts = (cartData: AddCart) =>
  fetchB2CAPI(`/cart/${cartData?.userID}/${cartData?.SKU}/${cartData?.buyQty}`);

export const removeFromCarts = (cartData: RemoveCart) =>
  fetchB2CAPI(`/remove_cart/${cartData?.userID}/${cartData?.SKU}`);

export const fetchAllPreOrderUserDetails = () =>
  fetchB2CAPI(`/preorder/all_user_details`);

export const removeProductFromCollection = (item_id: number) =>
  fetchB2CAPI(`/collections-items/${item_id}`);

export const removeAllFromPreorderCarts = (UserID: number) =>
  fetchB2CAPI(`/preorder/all_delete/${UserID}`);

export const getCollections = () => fetchB2CAPI(`/collections`);
export const toggleCollection = (collection_id: number) =>
  fetchB2CAPI(`/collections/${collection_id}`);
export const getCollectionDetail = (collection_id: number) =>
  fetchB2CAPI(`/collections-fetch/${collection_id}`);
export const fetchAllProductInventory = () =>
  fetchB2CAPI(`/collection_product`);
export const updateUserRole = (UserID: string) =>
  fetchB2CAPI(`/list/update_usertype/${UserID}`);
export const fetchB2CUsers = () => fetchB2CAPI("/admin/users");


export const getB2cOrderDetails = (order_ID: string) =>
  fetchB2CAPI(`/view_order/${order_ID}`);


export const updateB2cOrderStatus = (data: UpdateOrderStatus) =>
  fetchB2CAPI("/admin/Order/Status", {
    method: "POST",
    body: JSON.stringify(data),
  });